import { noop } from 'lodash'

export interface FileSlice {
    data: Blob
    start: number
    end: number
    size: number
}

export const S3_MIN_PART_SIZE_BYTES = 5 * 1024 * 1024

function sliceFile(file: any, start: number, end: number): Blob {
    // for old browsers
    const slice = file.mozSlice ? file.mozSlice : file.webkitSlice ? file.webkitSlice : file.slice ? file.slice : noop

    return slice.bind(file)(start, end)
}

function convertMbToBytes(mb: number): number {
    return mb * 1024 * 1024
}

export function getPartSizeBytes(): number {
    const configuredBytes = convertMbToBytes(
        Number(process.env.REACT_APP_UPLOAD_PART_SIZE_MB ? process.env.REACT_APP_UPLOAD_PART_SIZE_MB : 10),
    )
    return Math.max(configuredBytes, S3_MIN_PART_SIZE_BYTES)
}

export function getMultipartThresholdBytes(): number {
    return convertMbToBytes(
        Number(
            process.env.REACT_APP_UPLOAD_MULTIPART_THRESHOLD_MB
                ? process.env.REACT_APP_UPLOAD_MULTIPART_THRESHOLD_MB
                : 10,
        ),
    )
}

export function shouldUseMultipart(fileSize: number): boolean {
    return fileSize > getMultipartThresholdBytes()
}

export function processFile(file: File | Blob, sliceSize = getPartSizeBytes()): FileSlice[] {
    const size = file.size
    let start = 0
    let result: FileSlice[] = []
    for (let end = 0; end < size; start += sliceSize) {
        end = start + sliceSize
        if (end > size) {
            end = size
        }
        const slice = sliceFile(file, start, end)
        result = result.concat([
            {
                data: slice,
                start,
                end: end - 1,
                size,
            },
        ])
    }
    return result
}
